<p-toast/>
<main>
  @if (seats){
  <p-card
  >
    <section class="form">
      <div class="header">
        <h2><i class="fi fi-rr-building"></i> Group Settings</h2>
      </div>
      <section>
        <label for="group-name">Group Name</label>
        <input
          pInputText
          placeholder="Enter group name"
          id="group-name"
          [(ngModel)]="groupName"
        />
      </section>
      <div class="header bump">
        <div class="top-line"></div>
        <h2 class="top-bump"><i class="fi fi-rr-users"></i> Seat Management</h2>
      </div>
      <section class="seats">
        @for (seat of seats; track seat) {
          @if (seat !== null) {
            <div class="seat">
              <div class="left">
                <h3>{{seat.name}}</h3>
                <p>{{seat.email}}<p>
                <small>Added: {{seat.addedTime | date:'medium'}}</small>
              </div>
              <div class="right">
                <p-button
                  icon="pi pi-trash"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  [disabled]="seat.id === groupOwner"
                  (onClick)="removeUserFromSeat(seat.id)"
                />
              </div>
            </div>
          }
          @else {
            <div class="seat centered">
              <p>Empty Seat</p>
              <p-button
                label="Fill Seat"
                severity="info"
                [outlined]="true"
                icon="pi fi fi-rr-user-add"
                size="small"
                (onClick)="assignSeat()"
              />
            </div>
          }
        }
      </section>
    </section>
  </p-card>
  }
  @else {
    <p-progressSpinner/>
  }
</main>
